import { useEffect, useState } from "react";
import { API_ROUTES } from "../../utils/constants";
import axios from "axios";
import { JsonTool } from "utils/jsonTools";

export default function CarouselSlide() {
  //state
  const [slideActive, setSlideActive] = useState(0);
  const [data, setData] = useState();
  const dicBg = {
    1: "linear-gradient(45deg, #ff9a9e 0%, #fad0c4 99%, #fad0c4 100%)",
    2: "linear-gradient(to right, #f83600 0%, #f9d423 100%)",
    3: "linear-gradient(to right, #84fab0 0%, #8fd3f4 100%)",
    4: "linear-gradient(to right, #fbc2eb 0%, #a6c1ee 100%)",
    5: "linear-gradient(to right, #16a085 0%, #f4d03f 100%)",
  };

  useEffect(() => {
    const getDataSanPham05 = async () => {
      try {
        let body = {
          trangthaisanpham: 3,
          hangslide: [4, 5],
        };
        const query = JsonTool.convertToQueryString(body);
        const response = await axios.get(API_ROUTES.SANPHAM + "?" + query);
        let list = [...response?.data?.data];
        // list.length = 5;
        setData(list);
      } catch (error) {
        if (error.response && error.response.status === 500) {
          setAlert({
            alert: true,
            message: "Đã xảy ra lỗi 500. Vui lòng thử lại sau.",
            type: "error",
          });
        } else {
          console.log(error.response);
        }
        return;
      }
    };
    getDataSanPham05();
  }, []);

  // effect
  useEffect(() => {
    const interval = setInterval(() => {
      setSlideActive((prev) => {
        let next = prev + 1;
        if (prev == data?.length - 1) {
          next = 0;
        }
        return next;
      });
    }, 8000);
    return () => clearInterval(interval);
  }, [data]);

  //action
  const handleToClickCircle = (index) => (e) => {
    setSlideActive(index);
  };
  const handleToNext = () => {
    setSlideActive((prev) => {
      let next = prev + 1;
      if (prev == data?.length - 1) {
        next = 0;
      }
      return next;
    });
  };
  const handleToPrev = () => {
    setSlideActive((prev) => {
      let prevNumber = prev - 1;
      if (prev == 0) {
        prevNumber = data?.length - 1;
      }
      return prevNumber;
    });
  };

  const getIndex = (index) => {
    let zIndex = "z-30";
    let hidden = "";
    let transition = "-translate-x-full";
    if (slideActive == 0) {
      if (index != 0 && index != data?.length - 1) {
        zIndex = "z-20";
        transition = "translate-x-full";
        if (index !== 1) {
          hidden = "hidden";
        }
      }
    } else if (slideActive < data?.length - 1) {
      if (index !== slideActive && index !== slideActive - 1) {
        zIndex = "z-20";
        transition = "translate-x-full";
        if (index !== slideActive + 1) {
          hidden = "hidden";
        }
      }
    } else {
      if (index !== data?.length - 1 && index !== data?.length - 2) {
        zIndex = "z-20";
        transition = "translate-x-full";
        if (index !== 0) {
          hidden = "hidden";
        }
      }
    }
    return {
      zIndex: zIndex,
      hidden: hidden,
      transition: transition,
    };
  };
  return data && data.length > 0 ? (
    <div id="default-carousel" className="relative w-full">
      {/* <!-- Carousel wrapper --> */}
      <div className="relative h-56 overflow-hidden md:h-96">
        {data.map((item, index) => {
          return (
            <div
              className={`duration-700 ease-in-out absolute inset-0 transition-transform transform ${
                slideActive == index
                  ? "translate-x-0"
                  : getIndex(index).transition
              } ${getIndex(index).zIndex} ${getIndex(index).hidden}`}
              key={item?.id + "dataItem"}
            >
              {item?.image ? (
                <img
                  src={item?.image}
                  className="absolute block w-full -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 object-cover h-full"
                  alt={"background" + item?.name}
                  width={1500}
                  height={1500}
                ></img>
              ) : (
                <div
                  className={`absolute block w-full -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 object-cover h-full`}
                  style={{
                    backgroundImage: dicBg[index + 1],
                  }}
                ></div>
              )}
              <div className="absolute w-full h-full">
                <div className="absolute w-full h-full bg-slate-400 opacity-50"></div>
                <div className="absolute w-full h-full p-2 md:p-6 mb-4 flex items-center justify-center">
                  <div className="p-5 text-white flex items-center flex-col">
                    {item?.ten && (
                      <h2 className="text-center text-2xl md:text-[3rem] font-bold mb-2 md:mb-6 ">
                        {item?.ten?.toUpperCase()}
                      </h2>
                    )}
                    {item?.chuthe_ten && (
                      <p className="text-center text-lg md:text-2xl font-bold mb-2 ">
                        {item?.chuthe_ten}
                      </p>
                    )}
                    {!item?.ten && !item?.chuthe_ten && (
                      <p className="text-center text-lg md:text-2xl font-bold mb-2 ">
                        Đang cập nhập...
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {/* <!-- Slider indicators --> */}
      <div className="absolute z-30 flex -translate-x-1/2 bottom-5 left-1/2 space-x-3 rtl:space-x-reverse">
        {data &&
          data.length &&
          data.map((item, index) => (
            <button
              key={"circle_" + item.id + "_" + index}
              type="button"
              className={`w-3 h-3 rounded-full ${
                slideActive !== index ? "bg-slate-400" : "bg-slate-100"
              }`}
              aria-current="true"
              aria-label={`Slide ${item.id}`}
              onClick={handleToClickCircle(index)}
            ></button>
          ))}
      </div>
      {/* <!-- Slider controls --> */}
      <button
        type="button"
        className="absolute top-0 start-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
        onClick={handleToPrev}
      >
        <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/30 dark:bg-gray-800/30 group-hover:bg-white/50 dark:group-hover:bg-gray-800/60 group-focus:ring-4 group-focus:ring-white dark:group-focus:ring-gray-800/70 group-focus:outline-none">
          <svg
            className="w-4 h-4 text-white dark:text-gray-800 rtl:rotate-180"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 6 10"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 1 1 5l4 4"
            />
          </svg>
          <span className="sr-only">Previous</span>
        </span>
      </button>
      <button
        type="button"
        className="absolute top-0 end-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none"
        onClick={handleToNext}
      >
        <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/30 dark:bg-gray-800/30 group-hover:bg-white/50 dark:group-hover:bg-gray-800/60 group-focus:ring-4 group-focus:ring-white dark:group-focus:ring-gray-800/70 group-focus:outline-none">
          <svg
            className="w-4 h-4 text-white dark:text-gray-800 rtl:rotate-180"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 6 10"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m1 9 4-4-4-4"
            />
          </svg>
          <span className="sr-only">Next</span>
        </span>
      </button>
    </div>
  ) : (
    <div className="bg-white py-4">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="border-b border-gray-300">
          <h5 className="text-md font-bold tracking-tight text-gray-900">
            Không có dữ liệu
          </h5>
        </div>
      </div>
    </div>
  );
}
